<template>
  <main id="userBox">
    <ClientFiler
      :authed="false"
      :fixedRoot="true"
    />
  </main>
</template>

<script>
import ClientFiler from '@/components/filers/client'
export default {
  name: 'userBox',
  components: {
    ClientFiler
  },
  data () {
    return {
      config: {
        status: {
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
#userBox {
}
</style>
